import { isNilOrEmpty } from 'helpers';
import { flattenRules } from './flatten-rules';

export function removeEmptyRuleSets(ruleSet: any) {
  const rsCopy = { condition: ruleSet.condition, ui_condition_field: ruleSet.ui_condition_field, rules: []};
  ruleSet.rules.forEach((rule) => {
    if (!rule) {
      return;
    }
    if (rule['condition']) {
      if (!isNilOrEmpty(flattenRules(rule['rules']))) {
        rsCopy.rules.push(removeEmptyRuleSets(rule));
      }
    } else {
      rsCopy.rules.push(rule);
    }
  });
  return rsCopy;
}
